import cn from 'classnames';
import {extendTailwindMerge} from 'tailwind-merge';

const COLOR_REGEX = [/^text-color-/, /^text-\[#/, /^text-\[rgb/, /^text-\[rgba/];

const twMerge = extendTailwindMerge({
    // classGroups -  organizes classes for merging based on specific criteria,
    // enabling controlled combination of styles applied to web page elements.
    // for more details, visit - https://www.npmjs.com/package/tailwind-merge
    classGroups: {
        'text-size': [/^text-\d+$/],
        'text-color': COLOR_REGEX,
        'background-color': COLOR_REGEX,
    },
});

export function twx(...args) {
    return twMerge(cn(args));
}
